import React, { Component } from "react";
import styles from "./Checkout.module.css";
import axios from "./../../axios-questions";
import Aux from "./../Auxiliary/Auxiliary";

class Checkout extends Component {
  state = {
    name: "",
    cruiseName: "",
    currentLocation: "",
    contactNumber: "",
  };
  onChangeNameHandler = (event) => {
    this.setState({ name: event.target.value });
  };
  onChangeCruiseNameHandler = (event) => {
    this.setState({ cruiseName: event.target.value });
  };
  onChangeCurrentLocationHandler = (event) => {
    this.setState({ currentLocation: event.target.value });
  };
  onChangeContactNumberHandler = (event) => {
    this.setState({ contactNumber: event.target.value });
  };

  formSubmitHandler = () => {
    this.props.checkoutClose();
    this.props.loadStart();
    console.log("form");
    const order = {
      items: this.props.items,
      name: this.state.name,
      cruiseName: this.state.cruiseName,
      contactNumber: this.state.contactNumber,
    };
    axios
      .post("/orders.json", order)
      .then((res) => {
        console.log("Order Confirmed");
        this.props.loadEnd();
        this.props.confirmOrder();
      })
      .catch((err) => {
        console.log(err);
        this.props.loadEnd();
      });
  };
  render() {
    return (
      <Aux>
        <div className={styles.Form}>
          <input
            onChange={this.onChangeNameHandler}
            type="text"
            placeholder="Name"
          ></input>
          <input
            onChange={this.onChangeCruiseNameHandler}
            type="text"
            placeholder="Cruise Name"
          ></input>
          <input
            onChange={this.onChangeCurrentLocationHandler}
            type="text"
            placeholder="Current Location"
          ></input>{" "}
          <input
            onChange={this.onChangeContactNumberHandler}
            type="text"
            placeholder="Contact Number"
          ></input>
          <button onClick={this.formSubmitHandler} className={styles.Button}>
            Submit
          </button>
        </div>
      </Aux>
    );
  }
}

export default Checkout;
